var map = {
	"./animal_quiz/game/Game.vue": "765e",
	"./animal_quiz/highscore/Highscore.vue": "e944",
	"./animal_quiz/start/Start.vue": "4e80",
	"./animal_sounds/start/AnimalSoundsStart.vue": "691e",
	"./animals_in_order/game/Game.vue": "57e5",
	"./animals_in_order/highscore/Highscore.vue": "966e",
	"./animals_in_order/start/Start.vue": "2e3a",
	"./animals_in_order_blind/game/Game.vue": "e878",
	"./animals_in_order_blind/highscore/Highscore.vue": "ae45",
	"./animals_in_order_blind/start/Start.vue": "36ca",
	"./home/Home.vue": "5c28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3ad";